<div class="d-flex flex-column passengers-form">
  <ds-info-block class="mb-4"
    >Traveler names must match government-issued photo ID exactly.</ds-info-block
  >

  <form [formGroup]="form">
    <formly-form [form]="form" [fields]="fields" [model]="model" />
  </form>

  @if (form.touched && form.errors) {
    <div class="d-none d-md-block">
      @for (error of form.errors | keyvalue; track error.key) {
        <form-error [error]="error" class="mt-4" data-id="error" />
      }
    </div>
  }
</div>

<div class="d-md-none p-fixed form-errors">
  @if (form.touched && form.errors) {
    <div class="mx-4">
      @for (error of form.errors | keyvalue; track error.key) {
        <form-error [error]="error" class="mb-2" data-id="error" />
      }
    </div>
  }
</div>

<ng-content />

<div class="mt-md-8 mx-4 mx-md-0 d-flex flex-column-reverse flex-md-row">
  <ds-button
    label="Back"
    variant="secondary"
    leadingIcon="chevronLeft"
    (click)="tryBack()"
    [fullWidth]="true"
    class="mt-4 mt-md-0 w-md-unset"
    data-id="back"
  />

  <ds-button
    label="Continue"
    trailingIcon="chevronRight"
    (click)="submit()"
    [disabled]="form.disabled"
    [fullWidth]="true"
    class="ml-md-auto w-md-unset"
    data-id="submit"
  />
</div>
